import { NamedEntityMinDto } from './other';

export enum ReferralTypeCode {
    EMPLOYEE = 'EMPLOYEE',
    CONTACT = 'CONTACT',
    OTHER = 'OTHER',
}

export enum ReferralOtherSourceTypeCode {
    LEGAL_DIRECTORY = 'LEGAL_DIRECTORY',
    NETWORK_OR_ALLIANCE = 'NETWORK_OR_ALLIANCE',
    OTHER = 'OTHER',
}

export interface ReferralListItem {
    id: number;
    referralTypeCode: string;
    employee?: NamedEntityMinDto;
    referralSharePct?: number;
    companyParty?: NamedEntityMinDto;
    personParty?: NamedEntityMinDto;
    notes?: string;
    otherSourceTypeCode?: string;
}

export interface Referral {
    id: number;
    externalId?: string;
    referredPartyId?: number;
    referredMatterId?: number;
    referralTypeCode: string;
    employee?: NamedEntityMinDto;
    referralSharePct?: number;
    companyParty?: NamedEntityMinDto;
    personParty?: NamedEntityMinDto;
    notes?: string;
    otherSourceTypeCode?: string;
    efforts?: NamedEntityMinDto[];
}

export interface OutBoundReferralItem {
    referredParty: NamedEntityMinDto;
    personParty?: NamedEntityMinDto;
    matterCount: number;
    lastMatterOpenedDate: Date;
}

export interface ReferralDto {
    id: string | number | null;
    referredParty: { id: number } | null;
    referredMatter: { id: number } | null;
    referralTypeCode: string | null;
    employee: { id: number } | null;
    referralSharePct: number | null;
    companyParty: { id: number } | null;
    personParty: { id: number } | null;
    notes: string | null;
    otherSourceTypeCode: string | null;
    efforts: { id: number }[] | null;
}

export interface ReferralForm {
    id: string | number | null;
    externalId?: string | null;
    referredParty: { id: number } | null;
    referredMatter: { id: number } | null;
    referralType: { label: string; value: string } | null;
    employee: NamedEntityMinDto | null;
    referralSharePct: number | null;
    companyParty: { id: number; name: string } | null;
    personParty: { id: number; name: string } | null;
    notes: string | null;
    otherSourceType: { label: string; value: string } | null;
    efforts: { id: number; name: string }[] | null;
}
